import { NotificationType } from '@okletsplay/core';

export const BALANCE_NOTIFICATION_TYPES = [
  NotificationType.BalanceAutoSwapSuccessful,
  NotificationType.BalanceAutoSwapFailed,
  NotificationType.AffiliateProgramCommissionPayoutComplete,
];
